(() => {
  const roots = document.querySelectorAll('[data-ss-pdp]');

  roots.forEach((root) => {
    const mainImage = root.querySelector('[data-ss-pdp-main-image]');
    const thumbs = [...root.querySelectorAll('[data-ss-pdp-thumb]')];

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!mainImage || !thumb.dataset.image) return;
        mainImage.classList.add('is-changing');
        mainImage.removeAttribute('srcset');
        mainImage.src = thumb.dataset.image;
        mainImage.addEventListener('load', () => mainImage.classList.remove('is-changing'), { once: true });
        thumbs.forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
      });
    });

    const variantSelect = root.querySelector('[data-ss-pdp-variant]');
    const price = root.querySelector('[data-ss-pdp-price]');
    const compare = root.querySelector('[data-ss-pdp-compare]');
    const addButton = root.querySelector('[data-ss-pdp-add]');
    const addLabel = root.querySelector('[data-ss-pdp-add-label]');

    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        const available = option?.dataset.available === 'true';
        if (price && option?.dataset.price) price.textContent = option.dataset.price;
        if (compare) {
          compare.textContent = option?.dataset.compare || '';
          compare.hidden = !option?.dataset.compare;
        }
        if (addButton) addButton.disabled = !available;
        if (addLabel) addLabel.textContent = available ? root.dataset.addLabel : root.dataset.soldOutLabel;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      });
    }

    const saveButton = root.querySelector('[data-ss-pdp-save]');
    if (saveButton) {
      const storageKey = 'severn-saved-products';
      const handle = saveButton.dataset.productHandle;
      const readSaved = () => {
        try { return JSON.parse(window.localStorage.getItem(storageKey) || '[]'); }
        catch (_) { return []; }
      };
      const renderSaved = () => {
        const active = readSaved().includes(handle);
        saveButton.classList.toggle('is-saved', active);
        saveButton.setAttribute('aria-pressed', String(active));
        saveButton.setAttribute('aria-label', active ? 'Remove saved product' : 'Save product');
      };
      renderSaved();
      saveButton.addEventListener('click', () => {
        const saved = readSaved();
        const next = saved.includes(handle) ? saved.filter((item) => item !== handle) : [...saved, handle];
        try { window.localStorage.setItem(storageKey, JSON.stringify(next)); } catch (_) {}
        renderSaved();
      });
    }

    root.querySelectorAll('details').forEach((details) => {
      details.addEventListener('toggle', () => {
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', String(details.open));
      });
    });
  });
})();
